import(/* webpackMode: "eager" */ "/home/developer/www/bazzbet/bazz.bet/bzfront/src/app/[locale]/page/[slug]/page.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/developer/www/bazzbet/bazz.bet/bzfront/src/components/UI/BackButton/BackButton.tsx");
